import { useEffect, useState } from "react";
import QuestionList from "../QuestionList";
import SelectedQuestionsPanel from "./SelectedQuestionsPanel";
import Button from "./Button";
import "./SliderComponent.css";
const SliderComponent = (props) => {
    let { open, onClose, handleAddUpdateQuestions, selectedQuestions, batchId } = props;
    const [selectedQuestionIds, setSelectedQuestionIds] = useState([]);
    const [removedQuestionIds, setRemovedQuestionIds] = useState([]);

    useEffect(() => {
        if (open) {
            console.log("Slider Opened. Previously Selected:", selectedQuestions);
            setSelectedQuestionIds([...selectedQuestions]);
            setRemovedQuestionIds([]);
        }
    }, [open,selectedQuestions]);

    // QuestionList passes the complete new removal LIST, not a single id — it
    // calls this both to add an id and to drop one. Treating the argument as an
    // id pushed the whole array in as a single element, leaving a nested mess.
    // Nothing read it, so the bug was invisible; the pinned panel below writes
    // to the same state, so it is worth having it hold what it claims to.
    const handleRemoveChange = (ids) => {
        setRemovedQuestionIds(Array.isArray(ids) ? ids : [ids]);
    }

    // Unticking a question in the pinned "Selected questions" section.
    //
    // It must leave exactly the state QuestionList's own checkbox would, since
    // both feed the same Update Questions call: drop it from the selection, and
    // if it was on the test when the panel opened, record it as a removal so
    // the save detaches it.
    const handleSelectedPanelToggle = (id) => {
        setSelectedQuestionIds(prev => prev.filter(qid => qid !== id));
        if ((selectedQuestions || []).includes(id)) {
            setRemovedQuestionIds(prev => (prev.includes(id) ? prev : [...prev, id]));
        }
    };

    return (
        <>
            {/* Background Blur */}
            <div className={`Slider-overlay ${open ? "show" : ""}`} onClick={onClose}></div>

            <div className={`slider-panel ${open ? "open" : ""}`}>

                <div className="slider-header">
                    <Button
                        type="Delete-btn"
                        label="X"
                        onClick={onClose}
                    />
                    <h2>Add Questions</h2>
                </div>

                <div className="slider-content">
                    {/* Mounted only while the panel is open. The panel is
                        hidden with CSS, so rendering this unconditionally made
                        every test-detail page load fetch the whole question
                        list for a picker nobody had opened. */}
                    {open && (
                        <>
                            {/* The browse list below is paginated, so the questions
                                already on this test are spread across pages the admin
                                never sees. This shows the whole current selection up
                                front, where it can be reviewed and unticked. */}
                            <SelectedQuestionsPanel
                                selectedIds={selectedQuestionIds}
                                onToggle={handleSelectedPanelToggle}
                            />
                            <QuestionList
                                showCheckbox={true}
                                onSelectedChange={(ids) => setSelectedQuestionIds(ids)}
                                selectedChange={selectedQuestionIds}
                                previouslySelected={selectedQuestions}
                                removeChanged={removedQuestionIds}
                                onRemoveChanged={handleRemoveChange}
                                showAskedFilters={true}
                                askedBatchId={batchId}
                            />
                        </>
                    )}
                </div>
                <div className="footer-button">
                    <Button
                        type="save-btn"
                        label="Update Questions"
                        onClick={() => handleAddUpdateQuestions(selectedQuestionIds, removedQuestionIds)}
                    />

                    <Button
                        label="Cancel"
                        type="Delete-btn"
                        onClick={onClose}
                    />
                </div>

            </div>
        </>
    );

}
export default SliderComponent;
